import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import Box from "../Box";
import AlignContext, { inertAlignContextProps } from "./AlignContext";
import { splitPixels } from "./AlignProps";
import AlignInfo from "./AlignInfo";
import TextAligner from "./TextAligner";
export var getAlignItemsForOrigin = function getAlignItemsForOrigin(origin) {
  switch (origin) {
    case 'baseline':
      return 'baseline';

    case 'top':
      return 'flex-start';

    default:
      return 'stretch';
  }
};

// Sets a reference alignment context, wraps components in a baseline aligned
// container, and establishes the reference's baseline within that container.
var AlignBox = function AlignBox(props) {
  var children = props.children,
      _props$innerStyle = props.innerStyle,
      innerStyle = _props$innerStyle === void 0 ? {} : _props$innerStyle,
      _props$justifyContent = props.justifyContent,
      justifyContent = _props$justifyContent === void 0 ? 'flex-start' : _props$justifyContent,
      _props$reference = props.reference,
      reference = _props$reference === void 0 ? inertAlignContextProps : _props$reference,
      _props$reverse = props.reverse,
      reverse = _props$reverse === void 0 ? false : _props$reverse,
      debug = props.debug,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      remaining = _objectWithoutProperties(props, ["children", "innerStyle", "justifyContent", "reference", "reverse", "debug", "style"]);

  var isAligned = reference !== inertAlignContextProps;
  var direction = reverse ? 'row-reverse' : 'row';
  var origin = 'baseline';
  var alignItems = isAligned ? getAlignItemsForOrigin(origin) : undefined;
  var outerStyle = {
    position: 'relative'
  };
  var value = React.useMemo(function () {
    return isAligned ? _objectSpread({}, reference, {
      origin: origin,
      splitPixels: splitPixels
    }) : inertAlignContextProps;
  }, [isAligned, reference]);
  return /*#__PURE__*/React.createElement(AlignContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
    flex: {
      alignItems: alignItems,
      direction: direction
    },
    style: _objectSpread({}, outerStyle, style)
  }), debug && /*#__PURE__*/React.createElement(AlignInfo, _extends({}, debug, {
    height: reference.lineHeight
  })), /*#__PURE__*/React.createElement(TextAligner, null), /*#__PURE__*/React.createElement(Box, {
    flex: {
      direction: direction,
      alignItems: alignItems,
      justifyContent: justifyContent
    },
    flexBasis: "auto",
    flexGrow: 1,
    flexShrink: 1,
    style: _objectSpread({}, innerStyle, {
      lineHeight: 0
    })
  }, children)));
};

export default AlignBox;